import { StyleSheet } from "aphrodite/no-important";
import { colour, width } from "../style/base-theme";

export const styles = StyleSheet.create({
  header: {
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    backgroundImage: `linear-gradient(-180deg, ${
      colour.energy.primaryGradientTop
    } 0%, ${colour.energy.primaryGradientBottom} 100%)`
  },
  headerInner: {
    maxWidth: width.outer,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 auto"
  },
  loggedOut: {
    background: "#fff",
    color: colour.grey[100]
  },
  headerAssistedLiving: {
    backgroundImage: `linear-gradient(-180deg, ${colour.brand.blue} 0%, ${
      colour.brand.darkBlue
    } 100%)`
  },
  headerSetup: {
    backgroundImage: `linear-gradient(-180deg, ${colour.brand.blue} 0%, ${
      colour.brand.darkBlue
    } 100%)`
  },
  headerMainSetup: {
    backgroundImage: `linear-gradient(-180deg, ${
      colour.energy.primaryGradientTop
    } 0%, ${colour.energy.primaryGradientBottom} 100%)`
  },
  headerAssistedSetup: {
    backgroundImage: `linear-gradient(-180deg, ${
      colour.assisted.primaryGradientTop
    } 0%, ${colour.assisted.primaryGradientBottom} 100%)`
  },
  title: {
    color: "#fff",
    fontSize: 18,
    fontWeight: 600,
    flex: 1,
    textAlign: "center",
    flexGrow: 2,
    display: "flex",
    justifyContent: "center",
    alignContent: "center"
  },
  homeViewLogo: {
    height: 15
  },
  infoCareLogo: {
    height: 23
  },
  titleLoggedOut: {
    color: colour.grey[100]
  },
  back: {
    display: "flex",
    alignItems: "center",
    padding: "20px 10px",
    textDecoration: "none",
    flex: 1,
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: "#ffffff",
      content: '"\\E803"',
      paddingLeft: 10,
      paddingTop: 1
    }
  },
  backLoggedOut: {
    ":before": {
      color: colour.grey[100]
    }
  },
  close: {
    position: "absolute",
    right: 5,
    display: "flex",
    alignItems: "center",
    padding: "20px 10px",
    textDecoration: "none",
    flex: 1,
    ":after": {
      fontFamily: "informetis",
      fontSize: 24,
      color: "#ffffff",
      content: '"\\E808"',
      paddingLeft: 3,
      paddingTop: 1,
      transform: "rotate(45deg)"
    }
  },
  back__title: {
    fontSize: 14,
    fontWeight: 600,
    color: "#fff",
    marginLeft: 5
  },
  back__titleLoggedOut: {
    color: colour.grey[100]
  },
  account: {
    display: "flex",
    alignItems: "center",
    padding: "20px 10px",
    textDecoration: "none",
    flex: 1,
    justifyContent: "flex-end"
  },
  account__title: {
    fontSize: 14,
    fontWeight: 600,
    color: "#fff",
    marginRight: 10
  },
  account__icon: {
    width: 21,
    border: "1px solid #ffffff",
    borderRadius: "50%",
    marginRight: 10
  }
});
